import * as React from "react";
const SvgLaptop = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 18V3H2v15H0v2h24v-2h-2Zm-8 0h-4v-1h4v1Zm6-3H4V5h16v10Z",
  fill: "currentColor"
}));
export default SvgLaptop;